//-------------------------------------------------------------------------------------------------- Imports
import { Button } from "antd";
import { StyleSheet } from "../StyleSheet";
import { ClockCircleOutlined } from "@ant-design/icons";
import TextSplitter from "./TextSplitter";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { getDebtState } from "../stores/slices/checkDebtSlice";


//-------------------------------------------------------------------------------------------------- Component
const AlertModalReminder = () => {
    const navigate = useNavigate();
    const [showAlert, setShowAlert] = useState(false);
    const { hasDebt } = useSelector(getDebtState);

    useEffect(() => {
        setShowAlert(hasDebt);
    }, [hasDebt]);

    const handleButtonPayment = () => {
        setShowAlert(false);
        navigate("/payments");
    }

    return ((showAlert) ? (
        <>
            {
                <div style={styles.mainContainer}>
                    <div style={styles.cardContainer}>
                        <div style={styles.headerContainer}>
                            <ClockCircleOutlined style={styles.iconStyle} />
                        </div>
                        <div style={styles.bodyContainer}>
                            <h2 style={styles.titleColor}>{"¡Estimado usuario!"}</h2>
                            <TextSplitter style={{ margin: 5 }} text={"Tiene un saldo pendiente, lo invitamos a realizar su pago."} />
                        </div>
                    </div>
                    <div style={styles.buttonsContainer}>
                        <Button
                            style={styles.buttonStyle}
                            onClick={handleButtonPayment}
                        >
                            Pagar
                        </Button>
                        <Button
                            style={styles.buttonStyle}
                            onClick={() => setShowAlert(false)}
                        >
                            Ahora no
                        </Button>
                    </div>
                </div>
            }
        </>
    ) : (
        null
    ));
};

//-------------------------------------------------------------------------------------------------- Styles
const styles = StyleSheet.create({
    mainContainer: {
        position: "absolute",
        display: "flex",
        width: "100%",
        height: "100%",
        zIndex: 100,
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "rgb(0 0 0 / 60%)",
    },
    cardContainer: {
        width: 400,
        borderRadius: "15px",
    },
    headerContainer: {
        display: "flex",
        width: "100%",
        height: 150,
        borderRadius: "15px 15px 0px 0px",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#F74D09",
    },
    iconStyle: {
        fontSize: 80,
        color: "#ffffff",
    },
    bodyContainer: {
        display: "flex",
        flexDirection: "column",
        padding: "40px 20px 40px 20px",
        borderRadius: "0px 0px 15px 15px",
        alignItems: "center",
        textAlign: "center",
        justifyContent: "center",
        backgroundColor: "#ffffff",
    },
    buttonsContainer: {
        display: "flex",
        width: 450,
        padding: "40px 0px 40px 0px",
        alignItems: "center",
        justifyContent: "space-evenly",
    },
    buttonStyle: {
        height: 40,
        fontSize: 18,
        fontWeight: 600,
        padding: "0px 40px 0px 40px",
        borderRadius: 20,
        border: "none",
        color: "#ffffff",
        backgroundColor: "#0055c2",
    },
    titleColor: {
        margin: 0,
        marginBottom: 20,
        color: "#F74D09",
    },
});

//-------------------------------------------------------------------------------------------------- Exports
export default AlertModalReminder;